<div class="notes-label-v2">{{configData.label}}</div>
<div class = "dhl-notes-v2" [formGroup]="frmGroup" [class.disabled]="disabled">

    <div class = "dhl-show-notes-section-v2" *ngIf = "notes.length>0 ; else noNotesBlock">
      
        <div *ngFor = "let note of notes">      
            <div>
                <span class = "note-field1">{{note[configData.params[0]]}}</span>
                <span class = "pipe"></span>
                <span class = "note-field2">{{note[configData.params[1]] | date: 'MM/dd/yy, h:mm a'}}</span>
            </div>
            <div class = "note-field3">{{note[configData.params[2]]}}</div>
            <div class = "separator"></div>
            </div>         
    </div>
    <ng-template #noNotesBlock>
            <div class = "dhl-no-notes-section-v2"> {{configData.emptyMsg}} </div>
    </ng-template>
    
    <div class = "dhl-add-note-section-v2" >
        <div [ngClass]="{'textarea-outer': true, 'filled': textNote.nativeElement.value.length > 0}" >
            <label>{{configData.textareaLabel}}</label>
            <textarea #textareanote style="width:100%;" [class.disabled]="disabled" (input)="inputTextarea()" [attr.maxlength]="configData.maxChars"></textarea>
        </div>
        <div class="form-field-error" *ngIf="showError">
            <span class="error-icon">
                <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>

            <span class="error-text">
                {{errorMsg}} 
            </span>
        </div>
        <div class="add-notes-btn">            
           <div class="btn-align">
           <button type="button" class= "dhl-notes-button-v2" [class.disabled]="disabled" (click)=addNote($event)>
                <img src="./../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1960,24,24))">
                <span class = "button-font-v2">  Add New Note</span>
            </button>
        </div>
            <div class = "btn-align static-textarea-font-v2">{{counter}} characters remaining</div> 
       </div>
    </div>
</div>